import * as React from "react";
import {
  Page,
  Navbar,
  Block,
  List,
  ListItem,
  BlockTitle,
  Button,
  Col,
  Row,
  Icon,
} from "framework7-react";
import { removeToken } from "src/utils/utils";
import { COMPANY_NAME } from "../../utils/constants";

export default class PanelLeftPage extends React.Component {
  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  public logout() {
    const dialog = this.$f7?.dialog.preloader("Cerrando sesión");
    dialog?.open();

    setTimeout(() => {
      removeToken();
      dialog?.close();

      const form = document.querySelector("#login-form") as HTMLFormElement;
      form.reset();

      const loginPageDialog = document.querySelector(
        "#login-screen"
      ) as HTMLElement;

      this.$f7?.loginScreen.open(loginPageDialog);
    }, 600);
  }

  public changeLang(p1: any) {
    console.log(p1);

    console.log("yeah");
  }

  public render() {
    return (
      <Page panelLeftBreakpoint="400">
        <Navbar title={COMPANY_NAME} />

        <List>
          <ListItem
            className={"bg-white"}
            title="Language:"
            smartSelect
            smartSelectParams={{ openIn: "popover", closeOnSelect: true }}
          >
            <select
              onChange={this.changeLang}
              name="lang"
              defaultValue={["English"]}
            >
              <option value="EN">English</option>
              <option value="ES">Español</option>
              <option value="IN">Indonesian</option>
              <option value="PR">Português</option>
            </select>
          </ListItem>
        </List>
        <BlockTitle>Menu</BlockTitle>
        <List>
          <ListItem
            className={"bg-white"}
            link="/"
            title="Home"
            icon={"icon icon-home"}
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-home" />
          </ListItem>
          {/* INIT-GENERATOR.PHP ListItemConfig */}
          <ListItem
            className={"bg-white"}
            link="/unboxing/"
            title="UNBOXING"
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-box" />
          </ListItem>

          <ListItem
            className={"bg-white"}
            link="/battles/"
            title="Battles"
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-shield" />
          </ListItem>

          <ListItem
            className={"bg-white"}
            link="/how-it-work/"
            title="How It Work"
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-info" />
          </ListItem>

          {/* END-GENERATOR.PHP ListItemConfig */}

          <Block>
            <Row>
              <Col>
                <Button fill color="red" raised onClick={this.logout}>
                  Cerrar sesión
                </Button>
              </Col>
            </Row>
          </Block>
        </List>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PanelLeftPage.tsx